export const INCOME_P_AND_L_TOOLTIP_DATA : Record<string, any> = {
    "offline sales": {
      heading: 'Sales done by punching the order directly on Rista billing application (POS)',
      content: [
        {
          heading: 'Gross sales',
          description: 'Sum total of all the items sold through offline orders'
        },
        {
          heading: 'Discount',
          description : 'Sum total of all the discount given on the offline orders'
        },
        {
          heading: 'Charges',
          description: 'Sum total of charges levied on the offline orders'
        },
        {
          heading: 'Net',
          description: 'Gross - Discount + Charges (does not include taxes)'
        }
      ]
    },
    "swiggy sales": {
      heading: 'Sales done through orders coming from listings on Swiggy',
      content: [
        {
          heading: 'Gross sales',
          description: 'Sum total of all the items sold through Swiggy orders'
        },
        {
          heading: 'Discount',
          description : 'Sum total of all the discount given on the Swiggy orders'
        },
        {
          heading: 'Charges',
          description: 'Sum total of charges levied on the Swiggy orders'
        },
        {
          heading: 'Net',
          description: 'Gross - Discount + Charges (does not include taxes)'
        }
      ]
    },
    "zomato sales": {
      heading: 'Sales done through orders coming from listings on Zomato',
      content: [
        {
          heading: 'Gross sales',
          description: 'Sum total of all the items sold through Zomato orders'
        },
        {
          heading: 'Discount',
          description : 'Sum total of all the discount given on the Zomato orders'
        },
        {
          heading: 'Charges',
          description: 'Sum total of charges levied on the Zomato orders'
        },
        {
          heading: 'Net',
          description: 'Gross - Discount + Charges (does not include taxes)'
        }
      ]
    },
    "other online sales": {
      heading: 'Sales done through orders coming from other online sources like website or any other order aggregators',
      content: [
        {
          heading: 'Gross sales',
          description: 'Sum total of all the items sold through these orders'
        },
        {
          heading: 'Discount',
          description : 'Sum total of all the discount given on the these orders'
        },
        {
          heading: 'Charges',
          description: 'Sum total of charges levied on the these orders'
        },
        {
          heading: 'Net',
          description: 'Gross - Discount + Charges (does not include taxes)'
        }
      ]
    }
  }

  export const saleTypes = [
    "offline sales",
    "swiggy sales",
    "zomato sales",
    "other online sales",
  ];

  export const EXPENSE_TOOLTIP_CONTENT : Record<string, {heading: string, description: string}> = {
   'Cost of Goods sold' : {
        heading: 'Cost of raw material and supplies that was consumed in the preparation of items in the orders.',
        description: 'This information will come only if inventory items and recipes are added for the items that are sold to the customers in the inventory module'
    },
   'Commission' : {
       heading: 'Total commission that are given to Zomato and Swiggy for orders that are coming through the listing on Zomato and Swiggy.',
       description: 'This information will come only if commission percentage and value is defined for these sources in Rista'
   },
   'Fixed expense': {
       heading: 'Fixed expenses are expense like that are incurred on month and month basis. These are fixed in nature and does not change with change in sales',
       description: 'The information will come only if expense, under different heads, is added for the selected branch for the selected date range. If not added, you can add by clicking on add expense from the top of the page'
   },
   'PETTY CASH EXPENSES': {
       heading: 'Total sum of day to day expenses done during the operation at the outlet',
       description: 'This information will come only if petty cash management module is used to capture daily expenses done at the outlet'
   }
}

export const NUDGE_CONTENT : Record<string, any> = {
    'COST_OF_GOODS' : {
        heading: 'Track the cost of items sold',
        description: `To view these cost, subscribe to Rista Inventory module now! \n
        Call your account manager to get started with Inventory management`,
        CTA: ''
    },
    'Commission': {
        heading: 'Track your payable commissions',
        description: `To view these cost, upload your commission information for each of your Zomato and Swiggy listing now!
        Call your account manager to set this up.`
    },
    'PETTY_CASH': {
        heading: 'Track your daily cash expenses',
        description: `To view these cost, upload your daily cash expenses for the selected outlet now!`,
    },
    'FIXED_EXPENSE': {
        heading: 'Track your fixed expenses',
        description: 'To view these cost, upload your fixed expense for the selected branches for the selected rate range',
        CTA: 'Upload Expense Data'
    },
    'FIXED_EXPENSE1': {
        heading: 'Data is missing for the Fixed Expense Category',
        description: '',
    }
}

export const otherExpenseTypes = [
  {
    path: "utilities",
    label: "Expenses on Utilities",
  },
  {
    path: "supplies",
    label: "Expenses on Supplies",
  },
  {
    path: "marketing",
    label: "Expenses on Marketing",
  },
  {
    path: "repairAndMaintenance",
    label: "Expenses on Repair & Maintenance",
  },
  {
    path: "miscellaneous",
    label: "Miscellaneous Expenses",
  },
  {
    path: "employeeCost",
    label: "Employee Cost",
  },
  {
    path: "administrative",
    label: "Administrative Expenses",
  },
];

export const overallProfit = [
  {
    path: "grossProfitLoss",
    label: "Gross Profit / Loss",
    fontClass: "text-18 font-bold",
  },
  {
    path: "netProfitLoss",
    label: "Net Profit / Loss",
    fontClass: "text-18 font-bold",
  },
  {
    path: "netProfitMargin",
    label: "Net Profit Margin",
    fontClass: "text-18 font-bold",
    isAmount: false,
  },
]

export const UPLOAD_INSTRUCTION = [
  {
    heading: 'What is expense data?',
    description: 'Fixed expenses are expenses that do not change in conjunction with the level of activity. You can expect these expenses to stay the same, or close to it, over time. These costs can occur at any interval, but they’re typically monthly or yearly payments.'
  },
  {
    heading: 'How to add expense data?',
    description: [
      'Download the CSV template file and do not change the header (Expense heads) or any value in the first column (Branches) in the file.',
      'Enter expense incurred for the selected period (date range) for each branch under the respective expense heads (the date range will be selected while uploading).',
      'The added expense data will be equally distributed among the selected time duration. For example: if the Marketing expense for Branch 1 is added as INR 100 and while file uploading, the date is selected as 1st June to 5th June, then INR 20 will be saved as Marketing expense for Branch 1 for each of the above mentioned days.',
      'The data once uploaded will overwrite any existing data for the selected branch and date range.'
    ]
  }
]